'use strict';

module.exports = require('./InputGroup');